import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../../store/hooks";

const CentralLogo: React.FC = () => {
  const shouldSpinWheel = useAppSelector((state) => state.tab.shouldSpinWheel);
  const [shouldPulse, setShouldPulse] = useState(false);
  const [shouldFadeInfinite, setShouldFadeInfinite] = useState(true);
  const [text, setText] = useState("panel.drawingPanel.placeBet");
  const { t } = useTranslation();

  useEffect(() => {
    if (shouldSpinWheel) {
      setShouldPulse(true);
      setText("panel.drawingPanel.goodLuck");
      setShouldFadeInfinite(false);

      setTimeout(() => {
        setShouldPulse(false);
        setText("panel.drawingPanel.draw");
      }, 4000);

      setTimeout(() => {
        setShouldFadeInfinite(true);
        setText("panel.drawingPanel.placeBet");
      }, 16_000);
    }
  }, [shouldSpinWheel]);

  return (
    <div
      className={`spin_box 
      ${shouldPulse ? "pulse" : ""} 
      ${shouldFadeInfinite ? " fade_text_infinite" : ""} 
       disabled`}
    >
      <div className="spin_box_border">
        <div className="spin_box_content">
          <div className="spin_box_shadow">
            <div className="text_cont">
              <p className="spin_text">{t(text)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CentralLogo;
